import team from "./team";
import user from "./user";
import category from "./category";
import hotel from "./hotel";
import login from "./login";

export default [...team, ...user, ...category, ...hotel, ...login];
